<template>
<div class="full-calendar-header">
  <div class="header-left">
    <slot name="header-left">
    </slot>
  </div>
  <div class="header-center">
    <span class="title">{{title}}</span>
    <el-button class="prev-month" size="mini" @click.stop="goPrev">{{leftArrow}}</el-button>
    <el-button class="next-month" size="mini" @click.stop="goNext">{{rightArrow}}</el-button>
    <!-- @author jeee12 : 오늘 날짜로 이동 -->
    <el-button class="next-month" size="mini" @click.stop="goToday">TODAY</el-button>
  </div>
  <div class="header-right">
    <slot name="header-right">
    </slot>
  </div>
</div>
</template>
<script type="text/babel">
import dateFunc from './dateFunc';

export default {
  created() {
    this.dispatchEvent();
  },
  props: {
    currentDate: {},
    titleFormat: {},
    firstDay: {},
    monthNames: {},
  },
  data() {
    return {
      title: '',
      leftArrow: '<',
      rightArrow: '>',
      // headDate: new Date(),
      headDate: this.currentDate, // @author jeee12 현재가 아닌 특정 날짜를 기준으로 calendar 최초 로드
    };
  },
  watch: {
    currentDate(val) {
      if (!val) return;
      this.headDate = val;
      // console.log('currentDate', val);
      // this.headDate = JSON.parse(JSON.stringify(val))
      this.dispatchEvent(); // @author jeee12 추가, 특정 날짜로 이동 시 header title 변경되도록 수정
    },
  },
  methods: {
    goPrev() {
      this.headDate = this.changeMonth(this.headDate, -1);
      this.dispatchEvent();
    },
    goNext() {
      this.headDate = this.changeMonth(this.headDate, 1);
      this.dispatchEvent();
    },
    goToday() {
      // @author jeee12 : 오늘날짜로 이동
      this.headDate = this.changeMonth(new Date(), 0);
      this.dispatchEvent();
    },
    changeMonth(date, num) {
      const dt = new Date(date);
      return new Date(dt.setMonth(dt.getMonth() + num));
    },
    dispatchEvent() {
      this.title = dateFunc.format(this.headDate, this.titleFormat, this.monthNames);

      const startDate = dateFunc.getStartDate(this.headDate);
      const curWeekDay = startDate.getDay();

      // 1st day of this monthView
      let diff = parseInt(this.firstDay, 10) - curWeekDay;
      if (diff) diff -= 7;
      startDate.setDate(startDate.getDate() + diff);

      // the month view is 6*7
      const endDate = dateFunc.changeDay(startDate, 41);

      // 1st day of current month
      const currentDate = dateFunc.getStartDate(this.headDate);

      this.$emit('change',
        dateFunc.format(startDate, 'yyyy-MM-dd'),
        dateFunc.format(endDate, 'yyyy-MM-dd'),
        dateFunc.format(currentDate, 'yyyy-MM-dd'),
        this.headDate,
      );
    },
  },
};
</script>
<style lang="scss">
.full-calendar-header {
    display: flex;
    align-items: center;
    .header-left{
      //flex:2;
      width: 25%;
      min-width: 240px; //0312 수정
      float: left;
    }
    .header-right {
      width: 20%;
      margin-left: 7%;
      min-width: 170px; //0312 수정
      float: left;
      //flex:1;
    }
    .header-center {
      width: 50%;
      float: left;
      //flex:3;
        text-align: center;
        .title {
            margin: 0 10px;
        }
        .next-month,
        .prev-month {
            cursor: pointer;
        }
    }

    .el-radio-button__orig-radio:checked+.el-radio-button__inner{
      background-color: #38608e;
      outline: 0;
      border: 1px solid #38608e;
    }
    .el-radio-button:focus:not(.is-focus):not(:active){
      box-shadow: none;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/external/vue-fullcalendar/components/header.vue